import { Box, Container, Heading, Icons, Inline } from "@sembark-travel/ui-base"
import { Helmet } from "react-helmet-async"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../Auth"
import { NewPaymentPolicy } from "../../../PaymentPolicy"
import { useNavigate } from "../../../router-utils"

export default function NewPaymentPolicyPage() {
	const navigate = useNavigate()

	return (
		<>
			<Helmet>
				<title>Create Payment Policy</title>
			</Helmet>
			<ForbidUnlessAuthorized permission={PERMISSIONS.MANAGE_USERS}>
				<Box paddingY="4" borderBottomWidth="1">
					<Container>
						<Inline gap="4" alignItems="center">
							<Box
								cursor="pointer"
								onClick={() => navigate(-1)}
								title="Go back"
							>
								<Icons.ArrowLeft size="5" />
							</Box>
							<Heading as="h4">Create Payment Policy</Heading>
						</Inline>
					</Container>
				</Box>
				<Container paddingY="6">
					<NewPaymentPolicy />
				</Container>
			</ForbidUnlessAuthorized>
		</>
	)
}
